
    <!--
 * 横版-盲盒抽奖
 * @LastEditTime: Mon Jan 06 2025 17:26:50 GMT+0800 (China Standard Time)
 -->
 <template>
  <div id="u_c_JDH534"  :class="[`normal`,`u_c_JDH534`]" ><div id="u_c_I8LJ35"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_I8LJ35`]" ></div><div id="u_c_NS9Z36"  v-html="compData.subTitle" :class="[`normal`,`u_c_NS9Z36`]" ></div><div id="u_c_S08364"  :class="[`normal`,`u_c_S08364`]" ><span id="u_c_M9B665"  :class="[`normal txt`,`u_c_M9B665`]" >{{`${ langData.myCoupon }:`}}</span><span id="u_c_KHHK67"  :class="[`normal txt count`,`u_c_KHHK67`]" >{{`${ pageData.couponCount }`}}</span><a id="u_c_SSWG81" href="javascript:;" :class="[`normal txt`,`u_c_SSWG81`]" @click="u_c_SSWG81_event_MAWI24($event)">{{`[${ langData.checkGiftBtn }]`}}</a><a id="u_c_PMB269" href="javascript:;" :class="[`normal txt`,`u_c_PMB269`]" @click="u_c_PMB269_event_MAWI24($event)">{{`[${ langData.refresh }]`}}</a></div><div id="u_c_NO1G71"  :class="[`normal`,`u_c_NO1G71`]" ><div id="u_c_GAD717"  v-for="(giftItem, giftI) in compData.boxList" :key="giftI" :class="[`normal`,`u_c_GAD717`]" ><div id="u_c_L2HP72"  :style="`background-image:url(${ compData.giftPic })`" :class="[`${ giftItem.cur ? 'light' : '' }`,`normal`,`u_c_L2HP72`]" ></div></div></div><div id="u_c_S92S80"  :class="[`normal`,`u_c_S92S80`]" ><a id="u_c_KQKI48" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" v-if="!bridge.runInsdk()" :class="[`normal btn-light `,`u_c_KQKI48`]" @click="u_c_KQKI48_event_MAWI24($event)"><div id="u_c_SJT649"  :class="[`normal page-common-btn`,`u_c_SJT649`]" >{{`${ langData.gotoStoreBtn }`}}</div></a><a id="u_c_SC7H76" href="javascript:;" :style="`background-image:url(${ pageData['lottery-btn-bg'] })`" :class="[`${ compData.canClick ? 'btn-light' : '' }`,`normal  `,`u_c_SC7H76`]" @click="u_c_SC7H76_event_334420($event)"><div id="u_c_KVV377"  v-show="!(compData.is10 && pageData.couponCount >= 10)" :class="[`normal page-common-btn`,`u_c_KVV377`]" >{{`${ compData.canClick ? langData.lotteryBtn : langData.inLottery }`}}</div><div id="u_c_QXB019"  v-show="compData.is10 && pageData.couponCount >= 10" :class="[`normal page-common-btn`,`u_c_QXB019`]" >{{`${ compData.canClick ? langData.lottery10 : langData.inLottery }`}}</div></a></div><div id="u_c_J0VQ26"  v-if="!compData.canClick" :class="[`normal`,`u_c_J0VQ26`]" ><div id="u_c_539A28"  :class="[`normal`,`u_c_539A28`]" >{{`${ langData.blindBoxDrawingText }`}}</div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"subTitle":`活动期间，通过官网储值日储值满5美金，每日可获得3次机会开启盲盒`,"lotteryList":[{"name":"袜子1","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607104.png"},{"name":"袜子2","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960122.png"},{"name":"袜子3","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189606833.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`天使的选择
盲盒活动`,"is10":true},"zh-CN":{"subTitle":`活动期间，通过【官网储值页面】任意渠道储值，每天累计储值金额每次达到19.99USD，都会获得一张抽奖券；`,"lotteryList":[{"name":"加速60分钟*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"普通招募硬币*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"荣耀印记*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"精造装置*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"中级招募硬币*2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"5%OFF优惠券 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"升星选择补给箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"强化选择补给箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"7%OFF优惠券 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"高级招募硬币*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"VIP点数100点*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"9%OFF优惠券 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"器官强化方案*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"精密升星选择补给箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"5星英雄万能碎片*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`豪华礼盒`,"is10":true},"zh-TW":{"subTitle":`活動期間，通過【官網儲值頁面】任意管道儲值，每天累計儲值金額每次達到19.99USD，都會獲得一張抽獎券；`,"lotteryList":[{"name":"加速60分鐘*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"普通招募硬幣*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"榮耀印記*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"精造裝置*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"中級招募硬幣","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"5%off 優惠劵 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"升星選擇補給箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"強化選擇補給箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"7%off 優惠劵 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"高級招募硬幣*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"VIP點數100點*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"9%off 優惠劵 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"器官強化方案*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"精密升星選擇補給箱*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"5星英雄萬能碎片*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`豪華禮包`,"is10":true},"en-US":{"subTitle":`During the event, every $19.99 you top up every day via Puzzles & Survival's official website will grant you a Lucky Ticket.`,"lotteryList":[{"name":"60-min Speedup*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Basic Recruit Coin*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Mark of Glory*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Gear Refiner*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Int. Recruit Coin","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"5% OFF Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Promote Choice Box*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Enhance Choice Box*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"7% OFF Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Adv. Recruit Coin*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 VIP Pts*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"9% OFF Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Bioenhance Scheme*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"Promote Choice Box II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"5★ Hero Perfect Frag*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Deluxe Supply Box`,"is10":true},"ja-JP":{"subTitle":`イベント期間中、「公式チャージ画面」にて任意の決済方法で一日の合計チャージが19.99ドルに達するたびに、抽選券を獲得できます。`,"lotteryList":[{"name":"ブースト（60分間）*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"リクルートコイン*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"グローリー*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"ギア装置*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"ⓡ（リクルートコインミニ）","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"5%OFF\nクーポン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"選択型プロモート補給*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"選択型強化補給*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"7%OFF\nクーポン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Ⓡ（リクルートコイン）*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"VIPPt×100*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"9%OFF\nクーポン *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"器官強化プラン*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"選択型プロモート補給（エリート）*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"★5英雄の万能欠片*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`豪華記念ギフト`,"is10":true},"ko-KR":{"subTitle":`이벤트 기간 동안 공식 결제 플랫폼에서 19.99USD를 충전할 때마다 뽑기권 한 장이 주어집니다. 누적 충전 금액이 매일 리셋됩니다.`,"lotteryList":[{"name":"60분 가속*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"일반 모집 코인*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"영광 인장*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"정제 장치*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"중급 모집 코인","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"5% 할인쿠폰 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"승성 선택 보급 상자*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"강화 선택 보급상자*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"7% 할인쿠폰 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"고급 모집 코인*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"VIP 100포인트*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"9% 할인쿠폰 *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"신체 기관 강화 플랜*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"정밀 승성 선택 보급 상자*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"5성 영웅 만능 조각*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`축제 호화 선물함`,"is10":true},"th-TH":{"subTitle":`ช่วงกิจกรรม เพียงเติมเงินผ่าน [หน้าเพจเว็บไซต์ทางการ] สะสมครบครั้งละ 19.99USD ก็จะได้รับคูปองจับรางวัล 1 ใบ`,"lotteryList":[{"name":"เร่งสปีด60นาที*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"เหรียญเกณฑ์ I*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"ตรากลอรี่*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"เครื่องกลั่น*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"เหรียญเกณฑ์ II","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"คูปองลด 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"หีบเลือกอัปดาว*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"หีบเลือกตีบวก*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"คูปองลด 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"เหรียญเกณฑ์ III*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"แต้มVIPx100*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"คูปองลด 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"แผนตีบวกอวัยวะ*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"หีบเลือกอัปดาวก่อสร้าง*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"ชิปวิเศษฮีโร่ 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`กล่องสุดหรูงานฉลอง`,"is10":true},"vi-VN":{"subTitle":`Trong thời gian hoạt động, Nạp thông qua kênh bất kỳ, mỗi lần tích lũy nạp đến 19.99 USD, để nhận một tấm Vé Rút Thưởng;`,"lotteryList":[{"name":"Tăng tốc 60 phút*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Xu Chiêu Mộ-Thường*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Ấn Ký Vinh Dự*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Tinh Luyện Trang Bị*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Xu Chiêu Mộ-Trung","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"Phiếu Ưu Đãi 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Rương Lựa Chọn Tăng Sao*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Rương Chọn Cường Hoá*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"Phiếu Ưu Đãi 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Xu Chiêu Mộ-Cao*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 điểm VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"Phiếu Ưu Đãi 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"P.Án C.Hóa Nội Tạng*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"Rương Chọn Tăng Sao Tuyệt Mật*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"Mảnh Anh hùng 5 Sao Vạn Năng*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":``,"is10":true},"de-DE":{"subTitle":`Während des Events erhältst du für jede $19.99, die du jeden Tag über die offizielle Webseite von Puzzles & Survival auflädst, ein Glücksticket.`,"lotteryList":[{"name":"60 Min Beschleunigen*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Grund Rekrutmünze*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Zeichen des Ruhms*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Ausrüstung Verfeiner*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Mittl. Rekrutmünze","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"5% RABATT-Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Befördern Auswahlkiste*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Verbessern Auswahlkiste*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"7% RABATT-Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Fortg. Rekrutmünze*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 VIP Pkte*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"9% RABATT-Coupon *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Bioverstärkung Plan*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"Befördern Auswahlkiste II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"5★ Held-Perfektes Fragment*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Deluxe-Versorgungsbox`,"is10":true},"fr-FR":{"subTitle":`Pendant l'événement, chaque fois que vous rechargerez 19,99 $ par jour via le site officiel de Puzzles & Survival, vous obtiendrez un Ticket Chance.`,"lotteryList":[{"name":"Accélération 60-min*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Pièce recrutement de base*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Marque de gloire*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Raffineur d'équipement*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Pièce recrutement intermédiaire","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"Coupon 5% de Réduction *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Boîte choix promotion*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Boîte de renforcement au choix*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"Coupon 7% de Réduction *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Pièce recrutement av.*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 Pt. VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"Coupon 9% de Réduction *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Schéma Biorenforceur*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"Boîte choix promotion II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"Fragment parfait de héros 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Boîte d'approvisionnement Deluxe`,"is10":true},"es-ES":{"subTitle":`Durante el evento, recibirás un ticket de la suerte por cada $19.99 que recargues todos los días en el sitio web oficial de Puzzles & Survival.`,"lotteryList":[{"name":"Aceleración de 60 min*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Moneda de Reclutamiento Básica*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Marca de Gloria*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Refinador de Equipos*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Moneda de Reclutamiento Intermedia","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"Cupón de descuento del 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Caja de Selección de Promoción*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Mejora la Caja de Elección*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"Cupón de descuento del 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Moneda de Reclutamiento Avanzada*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 Puntos VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"Cupón de descuento del 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Plan de las Biomejoras*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"Caja de Selección de Promoción II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"Frag. Perfecto de Héroe 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Scatola Anniversario Deluxe`,"is10":true},"pt-PT":{"subTitle":`Durante o evento, cada $19,99 que você recarregar todos os dias através do site oficial do Puzzles & Survival, concederá a você um Bilhete da Sorte.
`,"lotteryList":[{"name":"Aceleração de 60 minutos*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Moeda Básica de Recrutamento*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Marca da Glória*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Refinador de Equipamentos*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Int. Moeda de Recrutar","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"Cupom de 5% de desconto *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Caixa de Escolha de Promoção*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Caixa da Escolha de Melhorias*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"Cupom de 7% de desconto *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Adv. Moeda de Recrutar*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 Pontos VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"Cupom de 9% de desconto *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Esquema de Melhoria de Órgãos*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"Caixa de Escolha de Promoção II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"Fragmento de Herói Perfeito 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Luxe Jubileum Kist`,"is10":true},"it-IT":{"subTitle":`Durante l'evento, ogni $19,99 che ricarichi tramite il sito ufficiale di Puzzles & Survival ti garantirà un Biglietto Fortunato.`,"lotteryList":[{"name":"Velocizz. 60-min*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Gettone Recluta Basica*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Marchio di Gloria*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Raffinatore Equip.*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Gettone Recluta Intermedia","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"Coupon SCONTO 5% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Scatola Scelta Promozione*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Scatola Scelta Migliora*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"Coupon SCONTO 7% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Gettone Recluta Avanzata*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 Pti VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"Coupon SCONTO 9% *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Schema Biopotenziatore*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"Scatola Scelta Promozione II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"Framm. Eroe Perfetto 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Luksusowe Pudełko Rocznicowe`,"is10":true},"tr-TR":{"subTitle":`Etkinlik boyunca, Puzzles & Survival'ın resmi web sitesi aracılığıyla her gün yüklediğin her $19,99 sana bir Şans Bileti verecek.`,"lotteryList":[{"name":"60-dk Hızlandırma*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Temel İşe Alım Parası*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Şan Mührü*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Teçhizat Arıtıcı*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Ara İşe Alım Parası","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"%5 İndirim Kuponu *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"İlerletme Seçim Kutusu*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Büyütme Seçimi Kutusu*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"%7 İndirim Kuponu *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Gel. İşe Alım Parası*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 VIP Puanı*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"%9 İndirim Kuponu *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Bio-Geliştirme Şeması*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"İlerletme Seçim Kutusu II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"5★ Kahraman Mükemmel Parça*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Caixa de Aniversário Deluxe`,"is10":true},"pl-PL":{"subTitle":`Podczas wydarzenia, każda kwota 19,99 USD, którą doładujesz codziennie za pośrednictwem oficjalnej strony Puzzles & Survival, przyzna Ci Szczęśliwy Bilet.
`,"lotteryList":[{"name":"60-min. Przyśpieszenie*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Moneta Rekruta Podstawowego*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Odznaka Chwały*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Rafiner Sprzętu*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Moneta Średniozaawansowanego Rekruta","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"Kupon 5% ZNIŻKI *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Pudełko z Wyborem Promocji*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Pudło Wyboru Wzmocnienia*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"Kupon 7% ZNIŻKI *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Moneta Rekruta Zaawansowanego*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 Pkt VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"Kupon 9% ZNIŻKI *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Biowzmacniacz Schemat*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"Pudełko z Wyborem Promocji II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"Idealny Frag. 5★ Herosa*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Шикарный юбилейный ящик`,"is10":true},"id-ID":{"subTitle":`Selama Event, lakukan Top Up dengan cara pembayaran apa pun. Jika akumulasi Top Up harian mencapai 19,99 USD, akan mendapat 1 Tiket Undi.`,"lotteryList":[{"name":"Speed up 60 menit*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"Normal Rekrut Coin*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"Mark of Glory*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"Gear Refiner*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"Medium Rekrut Coin","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"Kupon 5%off *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Star up Choice Supply Box*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"Enhance Choice Supply Box*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"Kupon 7%off *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Adv. Rekrut Coin*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 poin VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"Kupon 9%off *1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"Solusi Enhance Organ*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"Star up Choice Supply Box II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"Fragmen Hero Universal 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":``,"is10":true},"ar-SA":{"subTitle":`خلال الحدث، قم بالشحن من خلال أي وسيلة شحن، وفي كل يوم تصل فيه قيمة الشحن التراكمية إلى 19.99 دولار، ستحصل على تذكرة يانصيب.`,"lotteryList":[{"name":"تسريع 60 دقيقة*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594492928268.png"},{"name":"عملات التجنيد العادي*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594433537308.png"},{"name":"وسام المجد*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594427048363.png"},{"name":"مطور المعدات*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594460770353.png"},{"name":"عملات التجنيد المتوسط","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594476741838.png"},{"name":"1* قسيمة تخفيض 5%","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"صندوق ترقية النجوم*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594496258578.png"},{"name":"اختيار صندوق الإمدادات*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594453676069.png"},{"name":"1* قسيمة تخفيض 7%","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"عملات التجنيد المتقدم*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594456049284.png"},{"name":"100 نقطة VIP*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594463834907.png"},{"name":"1* قسيمة تخفيض 9%","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401857895.png"},{"name":"طريقة تقوية الأعضاء*1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594401861426.png"},{"name":"صندوق ترقية النجوم II*4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594462891433.png"},{"name":"قطعة بطل متعددة 5★*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/12/173382594475933334.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003072407734.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`Celebration Luxury Box`,"is10":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '盲盒抽奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const initActivity = inject("initActivity", () => {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const listData = inject("listData", {})
const canClickRefresh = inject("canClickRefresh", true)
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

const curPlatform = pagePlatform

watch(
  () => listData,
  (value) => {
    if (value && value.lotteryList) {
      let confList = _.cloneDeep(compData.lotteryList)
      compData.lotteryList = []
      value.lotteryList.forEach((item, index) => {
        if (confList[index]) {
          compData.lotteryList.push({
            state: pageData.lotteryType == "no_reset" ? item.send_status : 0,
            id: item.id,
            name: confList[index].name,
            pic: confList[index].pic,
            cur: index ? 1 : 0,
          })
        }
      })
      giftInfo.lotteryAward = compData.lotteryList
    }
  }, {
    deep: true
  }
)

const init = () => {
  compData.canClick = true
  compData.storeLink = getCurLink(compData.storeLink)
  compData.boxList.forEach((item, index) => {
    item.cur = index ? 0 : 1
  })
}

init()

const getGiftName = (data) => {
  let name = ""
  if (data.send_type == "sendSerial") {
    name = `${langData.giftCode}：${data.send_value}`
  } else {
    let curId = compData.lotteryList.findIndex((item) => item.id == data.id)
    if (~curId) {
      name = compData.lotteryList[curId].name
    }
  }

  return name
}

const excLottery = async () => {
  updateLight(ACTIVE_TIMER);
  let isMutiple = compData.is10 && pageData.couponCount >= 10
  let res = await excLotteryAjax(isMutiple)
  updateLight(TIMER);
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
    return
  }

  let curGiftType = isMutiple ? "sendVt" : res.data.send_type
  let curGiftPic = isMutiple ? "" : compData.giftPic
  let curGiftName = ""
  let curUse = 0

  if (isMutiple) {
    for (let i in res.data) {
      if (res.data[i].id != 0) {
        curUse++
        curGiftName += `${getGiftName(res.data[i])}<br/><br/>`
      }
    }
    if (curUse < 10) {
      curGiftName = `${curGiftName}${langData.lottery10error.replace(
        /{{n}}/,
        String(curUse)
      )}`
    }
  } else {
    curGiftName = getGiftName(res.data)
  }

  let currentUse = isMutiple ? curUse : 1

  pageData.couponCount = +pageData.couponCount - currentUse
  pageData.lotteryTime = +pageData.lotteryTime + currentUse

  showGetSucc(curGiftType, curGiftPic, curGiftName)
}

const excLotteryAjax = async (isMutiple) => {
  let curAction = isMutiple ? "batchLotteryAward" : "lotteryAward"
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=${curAction}`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=${curAction}`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=${curAction}`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  return res
}

// 盲盒轮闪
const TIMER = 1000;
const ACTIVE_TIMER = 100;
let animateID = undefined;
let latestTime = new Date().getTime()
const updateLight = (time) => {
  let nowTime = new Date().getTime()
  if (nowTime - latestTime > time) {
    latestTime = nowTime
    let latestIndex = compData.boxList.findIndex((item) => item.cur == 1)
    if (~latestIndex) {
      compData.boxList[latestIndex].cur = 0
      let nextIndex =
        latestIndex == compData.boxList.length - 1 ? 0 : latestIndex + 1
      compData.boxList[nextIndex].cur = 1
    }
  }
  window.cancelAnimationFrame(animateID)
  animateID = window.requestAnimationFrame(() => {
    updateLight(time)
  })
}
updateLight(TIMER);
      // 查看奖励按钮的click事件
      const u_c_SSWG81_event_MAWI24= async (e)=>{
        try {let arr = [];
compData.lotteryList.forEach(item=>{
  arr.push({
    name:item.name,
    pic:item.pic
  })
})
pageData.seeGift = arr;
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 更新按钮的click事件
      const u_c_PMB269_event_MAWI24= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 去充钱的click事件
      const u_c_KQKI48_event_MAWI24= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '前往储值',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
bridge.open(pageData.storeLink)
} catch (error) {console.log(error)}
      };
      // 抽奖按钮的click事件
      const u_c_SC7H76_event_334420= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if (!compData.canClick) return
compData.canClick = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "点击抽奖",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
await excLottery()
compData.canClick = true} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.default{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715384791446.png);
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.default{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.default{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.default{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.default{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.default{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.default{
.u_c_GAD717.normal{
position:relative;

}
}.default{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.default{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.default{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.default{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.default{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.default{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.default{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.zh-CN{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.zh-CN{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.zh-CN{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-CN{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.zh-CN{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.zh-CN{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.zh-CN{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.zh-CN{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.zh-CN{
.u_c_GAD717.normal{
position:relative;

}
}.zh-CN{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.zh-CN{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.zh-CN{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.zh-CN{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.zh-CN{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.zh-CN{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.zh-CN{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.zh-TW{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.zh-TW{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-TW{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.zh-TW{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.zh-TW{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.zh-TW{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.zh-TW{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.zh-TW{
.u_c_GAD717.normal{
position:relative;

}
}.zh-TW{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.zh-TW{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.zh-TW{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.zh-TW{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.zh-TW{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.zh-TW{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.zh-TW{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.en-US{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.en-US{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.en-US{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.en-US{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.en-US{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.en-US{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.en-US{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.en-US{
.u_c_GAD717.normal{
position:relative;

}
}.en-US{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.en-US{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.en-US{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.en-US{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.en-US{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.en-US{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.en-US{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.ja-JP{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.ja-JP{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.ja-JP{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ja-JP{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.ja-JP{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.ja-JP{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.ja-JP{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.ja-JP{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.ja-JP{
.u_c_GAD717.normal{
position:relative;

}
}.ja-JP{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.ja-JP{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.ja-JP{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.ja-JP{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.ja-JP{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.ja-JP{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.ja-JP{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.ko-KR{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.ko-KR{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.ko-KR{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ko-KR{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.ko-KR{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.ko-KR{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.ko-KR{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.ko-KR{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.ko-KR{
.u_c_GAD717.normal{
position:relative;

}
}.ko-KR{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.ko-KR{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.ko-KR{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.ko-KR{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.ko-KR{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.ko-KR{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.ko-KR{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.th-TH{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.th-TH{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.th-TH{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.th-TH{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.th-TH{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.th-TH{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.th-TH{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.th-TH{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.th-TH{
.u_c_GAD717.normal{
position:relative;

}
}.th-TH{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.th-TH{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.th-TH{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.th-TH{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.th-TH{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.th-TH{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.th-TH{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.vi-VN{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.vi-VN{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.vi-VN{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.vi-VN{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.vi-VN{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.vi-VN{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.vi-VN{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.vi-VN{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.vi-VN{
.u_c_GAD717.normal{
position:relative;

}
}.vi-VN{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.vi-VN{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.vi-VN{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.vi-VN{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.vi-VN{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.vi-VN{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.vi-VN{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.de-DE{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.de-DE{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.de-DE{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.de-DE{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.de-DE{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.de-DE{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.de-DE{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.de-DE{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.de-DE{
.u_c_GAD717.normal{
position:relative;

}
}.de-DE{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.de-DE{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.de-DE{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.de-DE{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.de-DE{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.de-DE{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.de-DE{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.fr-FR{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.fr-FR{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.fr-FR{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.fr-FR{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.fr-FR{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.fr-FR{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.fr-FR{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.fr-FR{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.fr-FR{
.u_c_GAD717.normal{
position:relative;

}
}.fr-FR{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.fr-FR{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.fr-FR{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.fr-FR{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.fr-FR{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.fr-FR{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.fr-FR{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.es-ES{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.es-ES{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.es-ES{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.es-ES{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.es-ES{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.es-ES{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.es-ES{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.es-ES{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.es-ES{
.u_c_GAD717.normal{
position:relative;

}
}.es-ES{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.es-ES{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.es-ES{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.es-ES{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.es-ES{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.es-ES{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.es-ES{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.pt-PT{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.pt-PT{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pt-PT{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.pt-PT{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.pt-PT{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.pt-PT{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.pt-PT{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.pt-PT{
.u_c_GAD717.normal{
position:relative;

}
}.pt-PT{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.pt-PT{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.pt-PT{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.pt-PT{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.pt-PT{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.pt-PT{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.pt-PT{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.it-IT{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.it-IT{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.it-IT{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.it-IT{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.it-IT{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.it-IT{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.it-IT{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.it-IT{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.it-IT{
.u_c_GAD717.normal{
position:relative;

}
}.it-IT{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.it-IT{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.it-IT{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.it-IT{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.it-IT{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.it-IT{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.it-IT{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.tr-TR{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.tr-TR{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.tr-TR{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.tr-TR{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.tr-TR{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.tr-TR{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.tr-TR{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.tr-TR{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.tr-TR{
.u_c_GAD717.normal{
position:relative;

}
}.tr-TR{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.tr-TR{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.tr-TR{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.tr-TR{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.tr-TR{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.tr-TR{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.tr-TR{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.pl-PL{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.pl-PL{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.pl-PL{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pl-PL{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.pl-PL{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.pl-PL{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.pl-PL{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.pl-PL{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.pl-PL{
.u_c_GAD717.normal{
position:relative;

}
}.pl-PL{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.pl-PL{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.pl-PL{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.pl-PL{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.pl-PL{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.pl-PL{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.pl-PL{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.id-ID{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.id-ID{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.id-ID{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.id-ID{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.id-ID{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.id-ID{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.id-ID{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.id-ID{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.id-ID{
.u_c_GAD717.normal{
position:relative;

}
}.id-ID{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.id-ID{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.id-ID{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.id-ID{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.id-ID{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.id-ID{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.id-ID{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}.ar-SA{
.u_c_JDH534.normal{
position:relative;
width:100.00vw;
height:54.17vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234290-21.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_JDH534.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_JDH534.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_JDH534.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.ar-SA{
.u_c_I8LJ35.normal{
position:relative;
width:58.23vw;
height:5.63vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_I8LJ35.normal.text{
width:100%;
height:auto;

}
}.ar-SA{
.u_c_NS9Z36.normal{
position:relative;
margin-top:2.24vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ar-SA{
.u_c_S08364.normal{
position:relative;
text-align:center;
margin-top:1.67vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_M9B665.normal{
position:relative;
font-size:1.46vw;
color:#ffffff;

}
}.ar-SA{
.u_c_KHHK67.normal{
position:relative;
margin-left:0.52vw;

}
}.ar-SA{
.u_c_SSWG81.normal{
position:relative;
margin-left:10.42vw;

}
}.ar-SA{
.u_c_PMB269.normal{
position:relative;
margin-left:2.60vw;

}
}.ar-SA{
.u_c_NO1G71.normal{
position:relative;
margin:auto;
margin-top:3.33vw;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:52.08vw;

}
}.ar-SA{
.u_c_GAD717.normal{
position:relative;

}
}.ar-SA{
.u_c_L2HP72.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:12.97vw;
height:17.92vw;

}
}.ar-SA{
.u_c_S92S80.normal{
position:relative;
margin:auto;
margin-top:2.81vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_KQKI48.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.ar-SA{
.u_c_SJT649.normal{
position:relative;
text-align:center;
margin-top:1.93vw;

}
}.ar-SA{
.u_c_SC7H76.normal{
position:relative;
width:22.86vw;
height:7.76vw;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.78vw;

}
}.ar-SA{
.u_c_KVV377.normal{
position:relative;
text-align:center;
margin-top:2.29vw;

}
}.ar-SA{
.u_c_QXB019.normal{
position:relative;
text-align:center;
margin-top:2.19vw;

}
}.ar-SA{
.u_c_J0VQ26.normal{
position:absolute;
top:0;
width:100%;
height:100%;
margin:auto;
left:0;
right:0;
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_539A28.normal{
position:absolute;
max-width:80%;
background-color:#000000;
top:33.18vw;
margin:auto;
font-size:1.15vw;
color:#ffffff;
padding:1.04vw;
border-radius:0.63vw;

}
}
</style>
